import {action, observable, toJS} from 'mobx';
import * as _ from 'lodash';
import {Context} from 'egg';
import {IGoogleSenseConfig, IRussianConfig} from '../component';
import {waAction as waLogAction} from '../../../common/wastat';
import { IscriptSrc } from '../../../../service/adService';

const airLogAcType: string = 'ad';

export default class AdvertisingStore {
  public config: any;
  public scriptSrc: IscriptSrc;

  private root: any;

  constructor(root: any, initialState: any) {
    this.root = root;
    if (initialState) {
      this.config = initialState.config;
      this.scriptSrc = initialState.scriptSrc;
    }
  }

  @action.bound
  public async ssrInit(initialState: any, ctx: Context): Promise<void> {
    this.config = initialState.config;
    this.scriptSrc = initialState.scriptSrc;
  }

  @action.bound
  public toJson() {
    const initConfig = {
      config: this.config,
      scriptSrc: this.scriptSrc,
    };
    return initConfig;
  }

  @action.bound
  public logSdkInit(googleSenseConfig: IGoogleSenseConfig) {
    utilLogSdkInit(googleSenseConfig);
  }

  @action.bound
  public logSdkFinish(googleSenseConfig: IGoogleSenseConfig, costTime: number) {
    utilLogSdkFinish(googleSenseConfig, costTime);
  }

  @action.bound
  public logRender(googleSenseConfig: IGoogleSenseConfig, costTime: number) {
    utilLogRender(googleSenseConfig, costTime);
  }

  @action.bound
  public logOnScreen(googleSenseConfig: IGoogleSenseConfig) {
    utilLogOnScreen(googleSenseConfig);
  }

  @action.bound
  public logClick(googleSenseConfig: IGoogleSenseConfig) {
    utilLogClick(googleSenseConfig);
  }

}

export interface IAdvertisingStoreInitData {
  googleSenseConfig?: IGoogleSenseConfig;
  russianConfig?: IRussianConfig;
  useRussian?: boolean;
}

// 打点文档请看 https://lark.alipay.com/skywalker/ezsk6m/lhol07
export enum GoogleSenseLogName {
  SdkInit = 'start_request', // 对应生命周期: google_sense_sdk_init
  SdkFinish = 'request', // 对应生命周期: google_sense_sdk_finish
  Render = 'image_load', // 对应生命周期: google_sense_render
  OnScreen = 'appear', // 对应生命周期: google_sense_onScreen
  Click = 'click', // 对应生命周期: google_sense_click
}

export function utilLogSdkInit(googleSenseConfig: IGoogleSenseConfig): void {
  waLogAction({
    ac_name: GoogleSenseLogName.SdkInit,
    ac_type: airLogAcType,
    adpf: 'js',
    adslot: googleSenseConfig.adSlot,
    adid: googleSenseConfig.adClient,
  });
}

export function utilLogSdkFinish(googleSenseConfig: IGoogleSenseConfig, costTime: number): void {
  waLogAction({
    ac_name: GoogleSenseLogName.SdkFinish,
    ac_type: airLogAcType,
    adpf: 'sdk',
    adslot: googleSenseConfig.adSlot,
    adid: googleSenseConfig.adClient,
    costTime,
  });
}

export function utilLogRender(googleSenseConfig: IGoogleSenseConfig, costTime: number): void {
  waLogAction({
    ac_name: GoogleSenseLogName.Render,
    ac_type: airLogAcType,
    adpf: 'sdk',
    adslot: googleSenseConfig.adSlot,
    adid: googleSenseConfig.adClient,
    costTime,
  });
}

export function utilLogOnScreen(googleSenseConfig: IGoogleSenseConfig): void {
  waLogAction({
    ac_name: GoogleSenseLogName.OnScreen,
    ac_type: airLogAcType,
    adpf: 'js',
    adslot: googleSenseConfig.adSlot,
    adid: googleSenseConfig.adClient,
  });
}

export function utilLogClick(googleSenseConfig: IGoogleSenseConfig): void {
  waLogAction({
    ac_name: GoogleSenseLogName.Click,
    ac_type: airLogAcType,
    adpf: 'js',
    adslot: googleSenseConfig.adSlot,
    adid: googleSenseConfig.adClient,
  });
}
